import React, { useState, useEffect } from 'react';
import {BrowserRouter as Router, Routes, Route, Navigate, Link} from 'react-router-dom';
import ScrollToTop from './component/scrollToTop/ScrollToTop';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaLockOpen, FaSignOutAlt, FaWhatsapp } from 'react-icons/fa';

// Home Pages Import
import DigitalAgency from './pages/DigitalAgency';
import CreativeAgency from './pages/CreativeAgency';
import PersonalPortfolio from './pages/PersonalPortfolio';
import HomeStartup from './pages/HomeStartup';
import CorporateAgency from './pages/CorporateAgency';

// Blog Import
import BlogGridView from './pages/BlogGrid';
import BlogCategory from './pages/Category';
import BlogArchive from './pages/Archive';
import BlogDetails from './pages/BlogDetails';

// Service 
import ServiceOne from './pages/ServiceOne';
import ServiceTwo from './pages/ServiceTwo';
import ServiceDetails from './pages/ServiceDetails';

// Project 
import ProjectGridOne from './pages/ProjectGridOne';
import ProjectGridTwo from './pages/ProjectGridTwo';
import ProjectGridThree from './pages/ProjectGridThree';
import ProjectGridFive from './pages/ProjectGridFive';
import ProjectGridFour from './pages/ProjectGridFour';
import ProjectDetails from './pages/ProjectDetails';

// Pages 
import AboutUs from './pages/AboutUs';
import OurOffice from './pages/OurOffice';
import OurClients from './pages/OurClients';
import Team from './pages/Team';
import TeamDetails from './pages/TeamDetails';
import CaseStudy from './pages/CaseStudy';
import CaseDetails from './pages/CaseStudyDetails';
import Testimonials from './pages/Testimonials';
import PricingTable from './pages/PricingTable';
import Typography from './pages/Typography';
import Contact from './pages/Contact';
import ErrorPage from './pages/404';
import ComingSoon from './pages/ComingSoon';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import DeleteAccount from './pages/DeleteAccount';
import AdminLogin from './pages/AdminLogin';

// Css Import
import './assets/scss/app.scss';

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      setIsAdmin(localStorage.getItem('ookey_admin_preview') === 'true');
    };
    checkAuth();
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('ookey_admin_preview');
    setIsAdmin(false);
    window.location.href = '/';
  };

  return (
    <Router>
      {/* Admin Floating Banner */}
      {isAdmin && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(90deg, #1e1b4b 0%, #312e81 100%)',
          color: '#e0e7ff',
          padding: '8px 16px',
          zIndex: 99999,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '13px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
          borderBottom: '1px solid rgba(255,255,255,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FaLockOpen className="text-warning" />
            <span><strong>Mode Pratinjau Admin Aktif</strong> — Anda dapat melihat dan menguji seluruh halaman sebelum dirilis.</span>
          </div>
          <button 
            onClick={handleLogout}
            className="btn btn-danger btn-sm py-1 px-3 d-flex align-items-center gap-1"
            style={{ borderRadius: '6px', fontSize: '12px' }}
          >
            <FaSignOutAlt /> Keluar Preview
          </button>
        </div>
      )}

		<ScrollToTop>
			<div style={{ paddingTop: isAdmin ? '42px' : '0px' }}>
				<Routes>
					{/* Public Unrestricted Pages */}
					<Route path={process.env.PUBLIC_URL + "/admin-login"} element={<AdminLogin />} />
					<Route path={process.env.PUBLIC_URL + "/privacy-policy"} element={<PrivacyPolicy />}/>
					<Route path={process.env.PUBLIC_URL + "/delete-account"} element={<DeleteAccount />}/>
					<Route path={process.env.PUBLIC_URL + "/terms-use"} element={<TermsOfUse />}/>
					<Route path={process.env.PUBLIC_URL + "/coming-soon"} element={<ComingSoon brandName="OOKEY" domain="ookey.id" />}/>

					{/* Conditional Pages: If not Admin, serve ComingSoon */}
					<Route path={process.env.PUBLIC_URL + "/"} element={isAdmin ? <DigitalAgency /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/digital-agency"} element={isAdmin ? <DigitalAgency /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/creative-agency"} element={isAdmin ? <CreativeAgency /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/personal-portfolio"} element={isAdmin ? <PersonalPortfolio /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/home-startup"} element={isAdmin ? <HomeStartup /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/corporate-agency"} element={isAdmin ? <CorporateAgency /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>

					{/* Blogs */}
					<Route path={process.env.PUBLIC_URL + "/blog-grid/"} element={isAdmin ? <BlogGridView /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/category/:slug"} element={isAdmin ? <BlogCategory /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/archive/:slug"} element={isAdmin ? <BlogArchive /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/blog-details/:id"} element={isAdmin ? <BlogDetails /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>

					{/* Service */}
					<Route path={process.env.PUBLIC_URL + "/products"} element={isAdmin ? <ServiceOne /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/service-one/"} element={<Navigate to={process.env.PUBLIC_URL + "/products"} replace />}/>
					<Route path={process.env.PUBLIC_URL + "/service-two/"} element={isAdmin ? <ServiceTwo /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/service-details/:slug"} element={isAdmin ? <ServiceDetails /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>

					{/* Project  */}
					<Route path={process.env.PUBLIC_URL + "/project-grid-one"} element={isAdmin ? <ProjectGridOne /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/project-grid-two"} element={isAdmin ? <ProjectGridTwo /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/project-grid-three"} element={isAdmin ? <ProjectGridThree /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/project-width-one"} element={isAdmin ? <ProjectGridFour /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/project-width-two"} element={isAdmin ? <ProjectGridFive /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/project-details/:slug"} element={isAdmin ? <ProjectDetails /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>

					{/* Pages  */}
					<Route path={process.env.PUBLIC_URL + "/about-us"} element={isAdmin ? <AboutUs /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/our-office"} element={isAdmin ? <OurOffice /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/our-clients"} element={isAdmin ? <OurClients /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/team"} element={isAdmin ? <Team /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/team-details/:slug"} element={isAdmin ? <TeamDetails /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/case-study"} element={isAdmin ? <CaseStudy /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/case-details/:slug"} element={isAdmin ? <CaseDetails /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/testimonials"} element={isAdmin ? <Testimonials /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/pricing-table"} element={isAdmin ? <PricingTable /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/typography"} element={isAdmin ? <Typography /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/contact"} element={isAdmin ? <Contact /> : <ComingSoon brandName="OOKEY" domain="ookey.id" />}/>
					<Route path={process.env.PUBLIC_URL + "/404"} element={<ErrorPage />}/>
					<Route path="*" element={<Navigate to="/" replace />} />
				</Routes>
			</div>
		</ScrollToTop>
    </Router>
  )
}

export default App;
